'use client';

import Image from 'next/image';

import PinIcon from '@/fo/icons/base/doctor/pin.svg';

import { DoctorFeature } from '../../types';

import { styles } from './Marker.styles';

interface MarkerProps {
  feature: DoctorFeature;
  onClick: (feature: DoctorFeature) => void;
  isSelected: boolean;
  mode: 'profile' | 'search';
}

export function Marker({ feature, onClick, isSelected, mode }: MarkerProps) {
  const slots = styles({ isSelected: mode === 'search' && isSelected });

  const onMarkerClick = () => {
    onClick(feature);
  };

  return (
    <button
      className={slots.marker()}
      onClick={onMarkerClick}
    >
      <div className={slots.inner()}>
        {feature.properties.photo && mode === 'search' && (
          <Image
            src={feature.properties.photo}
            className={slots.image()}
            alt={feature.properties.photo_alt || feature.properties.full_name}
            width={48}
            height={48}
          />
        )}
        {mode === 'profile' && <PinIcon />}
      </div>
    </button>
  );
}
